<div
  id="my-box-content-preview-{{ fileId }}{{ id }}"
  class="container"
  [ngStyle]="{ height: height() ? height()!.toString() + 'px' : '650px' }"
></div>
